import React from 'react';
import { BreadcrumbItem, Breadcrumbs } from '../Breadcrumbs/Breadcrumbs';
import { Container, Header, TitleContainer, Title, Actions, Body } from './Page.styles';
import Skeleton from '../Skeleton/Skeleton';
import classNames from 'classnames';

export interface PageProps
  extends React.PropsWithChildren,
    React.HTMLAttributes<HTMLDivElement> {
  header?: string | React.ReactNode | BreadcrumbItem[] | 'loading';
  headerActions?: React.ReactNode;
  fixedHeader?: boolean;
  actions?: React.ReactNode;
  banner?: React.ReactNode;
  className?: string;
}

export function Page({
  header,
  fixedHeader,
  headerActions,
  actions,
  banner,
  children,
  className,
  ...rest
}: PageProps) {
  return (
    <Container {...rest} className={classNames({ fixedHeader }, className)}>
      {banner}
      <Header className="header">
        <TitleContainer>
          {header === 'loading' ? (
            <Skeleton width={400} height={20} />
          ) : Array.isArray(header) ? (
            <Breadcrumbs items={header} />
          ) : (
            <Title role="heading" aria-level={1}>
              {header}
            </Title>
          )}
          {headerActions}
        </TitleContainer>
        {actions && <Actions>{actions}</Actions>}
      </Header>
      <div className="containerBody">
        <Body className="body">{children}</Body>
      </div>
    </Container>
  );
}
